import React from 'react';
import { Card, ToggleContainer, Select, Form, TooltipHelp } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from './settings.module.css';

export default function TicketOfficeSettingsForm({ ticketOfficeSettingsForm, setTicketOfficeSettingsForm }) {
    const { t } = useTranslation();

    const accept_all_stats_value = [
        { text: t('ticket.ticket_offices.parameters.form.settings.accept_stats_no_select'), value: 'ACCEPT_STATS_NO' },
        { text: t('ticket.ticket_offices.parameters.form.settings.accept_stats_partner_select'), value: 'ACCEPT_STATS_PARTNER' },
        { text: t('ticket.ticket_offices.parameters.form.settings.accept_stats_guichet'), value: 'ACCEPT_STATS_GUICHET' }
    ];

    accept_all_stats_value.forEach((field, key) => {
        if (ticketOfficeSettingsForm.accept_all_stats === String(key)) {
            setTicketOfficeSettingsForm('accept_all_stats', field.value);
        }
    });

    const placement_options = [
        { text: t('ticket.ticket_offices.parameters.form.settings.placement_auto'), value: 1 },
        { text: t('ticket.ticket_offices.parameters.form.settings.placement_manual'), value: 2 },
        { text: t('ticket.ticket_offices.parameters.form.settings.placement_both'), value: 3 }
    ];

    return (
        <div>
            <Card.FormStep
                title={t('ticket.ticket_offices.parameters.form.settings.title')}
                subtitle={t('ticket.ticket_offices.parameters.form.settings.descr3')}
                id="ticket-office-form-settings"
                rightComponent
            >
                <Form.Field style={{ marginBottom: '0' }}>
                    <Form.Label>
                        {t('ticket.ticket_offices.parameters.form.settings.accept_all_stats_label')}
                        <TooltipHelp title={t('ticket.ticket_offices.parameters.form.settings.accept_all_stats_helplabel')} mini={false} position={'top'} />
                    </Form.Label>
                    <Select
                        options={accept_all_stats_value}
                        value={ticketOfficeSettingsForm.accept_all_stats}
                        onChange={(_, { value }) => setTicketOfficeSettingsForm('accept_all_stats', value)}
                    />
                    <ToggleContainer
                        className={Style['toogle_container_margin']}
                        checked={ticketOfficeSettingsForm.counter_printing}
                        tooltipProps={{ position: 'top' }}
                        title={t('ticket.ticket_offices.parameters.form.settings.counter_printing_label')}
                        helpLabel={t('ticket.ticket_offices.parameters.form.order.counter_printing_helplabel')}
                        onChange={(_, { checked }) => setTicketOfficeSettingsForm('counter_printing', checked)}
                    />

                    <ToggleContainer
                        className={Style['toogle_container_margin']}
                        checked={ticketOfficeSettingsForm.render_quotas}
                        tooltipProps={{ position: 'top' }}
                        title={t('ticket.ticket_offices.parameters.form.settings.render_quotas_label')}
                        helpLabel={t('ticket.ticket_offices.parameters.form.order.render_quotas_helplabel')}
                        onChange={(_, { checked }) => setTicketOfficeSettingsForm('render_quotas', checked)}
                    />
                    <Form.Label>
                        {t('ticket.ticket_offices.parameters.form.settings.placement_type_label')}
                        <TooltipHelp title={t('ticket.ticket_offices.parameters.form.settings.placement_type_helplabel')} position="top" />
                    </Form.Label>
                    <Select
                        options={placement_options}
                        value={ticketOfficeSettingsForm.type_placement}
                        onChange={(_, { value }) => setTicketOfficeSettingsForm('type_placement', value)}
                    />
                </Form.Field>
            </Card.FormStep>
        </div>
    );
}
